import { InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SoundDefinition } from './components/header/sound-definition';
import { SideMenuAction } from './components/side-menu/side-menu-action';
import { Theme } from './components/theme-select/theme';

export const DEFAULT_SIDEMENU_TITLE = new InjectionToken<
  Observable<string | null> | string
>('Default side menu title');

export const DISABLE_NOTIFICATIONS = new InjectionToken<boolean>(
  'Disable notifications icon and features',
  { providedIn: 'root', factory: () => false }
);

export const SPEECH_RECOGNITION = new InjectionToken<boolean>(
  'Is speech recognition available?',
  { providedIn: 'root', factory: () => false }
);

export const AVAILABLE_SOUNDS = new InjectionToken<SoundDefinition[]>(
  'Available notification sounds',
  { providedIn: 'root', factory: () => [] }
);

export const SHOW_MENU_OBSERVABLE = new InjectionToken<Observable<boolean>>(
  'Should main header functionality be available',
  { providedIn: 'root', factory: () => of(true) }
);

export const APP_FOOTER_TEXT = new InjectionToken<string>('Footer Text', {
  providedIn: 'root',
  factory: () => ''
});

export const APP_FOOTER_LINK = new InjectionToken<string>('Footer Text link', {
  providedIn: 'root',
  factory: () => ''
});

export const AVAILABLE_THEMES = new InjectionToken<Theme[]>(
  'Available themes',
  {
    providedIn: 'root',
    factory: () => [
      { themeName: 'default-theme', isDark: false },
      { themeName: 'green-yellow', isDark: false },
      { themeName: 'purple-amber', isDark: false },
      { themeName: 'cyan-amber', isDark: false },
      { themeName: 'pink-bluegrey', isDark: true },
      { themeName: 'lightblue-lime', isDark: true }
    ]
  }
);

export const STATIC_SIDE_MENU_ACTIONS = new InjectionToken<SideMenuAction[]>(
  'Static side menu actions'
);

export const SIDE_MENU_ACTIONS = new InjectionToken<
  Observable<SideMenuAction[]>
>('Side menu actions', {
  providedIn: 'root',
  factory: () => of(new Array<SideMenuAction>())
});
